import { render, staticRenderFns } from "./ArabicManageAccount.vue?vue&type=template&id=27806575"
import script from "./ArabicManageAccount.vue?vue&type=script&lang=js"
export * from "./ArabicManageAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports